import axios from 'axios';

const uploadAccount = (data) => {
  return axios.post('/api/account/upload', data);
};

const validateAccount = (data) => {
  return axios.post('/api/account/validate', data);
};

const validateAccounts = (data) => {
  return axios.post('/api/account/validate-accounts', data);
};

const validateAccountsOld = (data) => {
  return axios.post('/api/account/validate-accounts-old', data);
};

const downloadAccountTemplate = () => {
  return axios.get('/api/account/download/');
};

const getBudgetOverviews = (config) => {
  return axios.get('/api/account/overview', config);
};

const saveMapping = (mapping) => {
  return axios.post('/api/mapping', mapping);
};

const getAllMappingsByObjectType = () => {
  return axios.get('/api/mapping/all');
};

const getFunds = (cancelToken) => {
  return axios.get('/api/account/funds', { cancelToken });
};

const getAccountTypes = () => {
  return axios.get('/api/account/account-types');
};

const checkForAccountData = (config) => {
  return axios.get('/api/account/check-for-account-data', config);
};

const getAccountCodesByBudgetId = (budgetId) => {
  return axios.post('/api/account/account-codes-by-budget-id', { budgetId });
};

const addOrEditFunds = (data) => {
  return axios.post('/api/account/addOrEditFund', {funds: data});
};

const getManageDataInfo = () => {
  return axios.get('/api/account/getManageDataInfo');
};

const addOrEditManagedData = (data, columnToUpdate) => {
  return axios.post('/api/account/addOrEditMangedData', {data, columnToUpdate});
};

const getAllItems = () => {
  return axios.post('/api/account/all-items', {});
};

const addOrEdit = (data) => {
  return axios.post('/api/account/add-or-edit', data);
};

const deleteItems = (ids) => {
  return axios.delete('/api/account/delete-items', { data: { ids }});
};

export const checkDeleteItems = (ids) => {
  return axios.post('/api/account/check-delete-items', { ids });
};

const combineItems = (mainItem, itemIds, currentTabValue) => {
  return axios.post('/api/account/combine-items', { mainItem, itemIds, objectType: currentTabValue });
};

export {
  uploadAccount,
  validateAccount,
  validateAccounts,
  validateAccountsOld,
  downloadAccountTemplate,
  getBudgetOverviews,
  saveMapping,
  getAllMappingsByObjectType,
  getFunds,
  getAccountTypes,
  checkForAccountData,
  getAccountCodesByBudgetId,
  addOrEditFunds,
  getManageDataInfo,
  addOrEditManagedData,
  getAllItems,
  addOrEdit,
  deleteItems,
  combineItems
};
